import React, { useRef } from 'react';
import useTilt from './useTilt';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * An image frame that leans towards the pointer with a soft light sheen
 * (premium E1). The frame keeps its own aspect ratio (no layout shift);
 * the tilt is a transform on this element only. Desktop mouse / trackpad
 * only, never on touch or with reduced motion (see useTilt).
 */
const TiltFrame = ({ as: Tag = 'div', className = '', style, children, sheen = true, tilt = true, ...rest }) => {
  const ref = useRef(null);
  const { language } = useLanguage();
  useTilt(ref, { rtl: language === 'ar', disabled: !tilt });
  return (
    <Tag ref={ref} className={`anum-tilt ${className}`.trim()} style={style} {...rest}>
      {children}
      {sheen && <span className="anum-sheen" aria-hidden="true" />}
    </Tag>
  );
};

export default TiltFrame;
